import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import EditAR from '../../components/AR/editAR';
import {
  fetchARInvoices,
  editAR,
  deleteAR,
  bounceCheck,
  fetchARCredits,
  fetchARDetail,
  clearCredits,
  clearARForm
} from '../../actions/arap_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { checkPassword, clearCheckPassword } from '../../actions/settings_actions';

const isNumeric = (n) => !isNaN(parseFloat(n)) && isFinite(n);

const validate = (values) => {
  const errors = {};

  if (values.TotalPayment && !isNumeric(values.TotalPayment)) {
    errors.TotalPayment = 'Enter a number!';
  }

  if (values.TotalPayment < 0) {
    errors.TotalPayment = 'Positive numbers only!';
  }

  if (values.Discount && !isNumeric(values.Discount)) {
    errors.Discount = 'Enter a number!';
  }

  if (values.Discount && values.Discount < 0) {
    errors.Discount = 'Positive numbers only!';
  }

  if (values.PenaltyAmount && !isNumeric(values.PenaltyAmount)) {
    errors.PenaltyAmount = 'Enter a number!';
  }

  if (values.PenaltyAmount && values.PenaltyAmount < 0) {
    errors.PenaltyAmount = 'Positive numbers only!';
  }

  if (values.WaiveAmount && !isNumeric(values.WaiveAmount)) {
    errors.WaiveAmount = 'Enter a number!';
  }

  if (!values.Customer) {
    errors.Customer = 'Required';
  }

  if (!values.Account) {
    errors.Account = 'Required';
  }

  if (!values.TotalPayment) {
    errors.TotalPayment = 'Required';
  }

  if (!values.Method) {
    errors.Method = 'Required';
  }

  return errors;
};

const editARForm = reduxForm({
    form: 'editAR',
    enableReinitialize: true,
    destroyOnUnmount: true,
    touchOnChange: true,
    touchOnBlur: false,
    validate,
})(EditAR);

const selector = formValueSelector('editAR');

function mapStateToProps(state) {
    const customer_id = selector(state, 'Customer');
    const credits = selector(state, 'Credits');

    const invoiceDate = selector(state, 'InvoiceDate');
    const paymentDate = selector(state, 'PaymentDate');
    const penaltyAmount = selector(state, 'PenaltyAmount');

    const method = selector(state, 'Method');
    const checkNum = selector(state, 'CheckNum');
    const account = selector(state, 'Account');
    const discount = selector(state, 'Discount');
    const totalPayment = selector(state, 'TotalPayment');
    const waive = selector(state, 'Waive');
    const waiveAmount = selector(state, 'WaiveAmount');
    const note = selector(state, 'Note');
    return {
        ...state.arap.bounceCheck,

        customer_id,
        credits,
        invoiceDate,
        paymentDate,
        penaltyAmount,
        method,
        checkNum,
        account,
        discount,
        totalPayment,
        waive,
        waiveAmount,
        note,

        invoices: state.arap.invoices,
        invoicesIsLoading: state.arap.invoicesIsLoading,
        invoicesError: state.arap.invoicesError,
        arEdited: state.arap.arEdited,
        arEditError: state.arap.arEditError,
        arIsEditing: state.arap.arIsEditing,
        arDetail: state.arap.arDetail,
        arDetailError: state.arap.arDetailError,
        arDetailIsLoading: state.arap.arDetailIsLoading,


        credits: state.arap.credits,
        creditsIsLoading: state.arap.creditsIsLoading,
        creditsError: state.arap.creditsError,

        userPermissions: state.auth.userPermissions,
        checkPassword: state.settings.checkPassword,
        checkPasswordSuccess: state.settings.checkPasswordSuccess,
        checkPasswordFailure: state.settings.checkPasswordFailure,

        initialValues: state.arap.arDetail,
    };
}


export default connect(mapStateToProps, {
    fetchARInvoices,
    fetchARCredits,
    fetchARDetail,
    editAR,
    deleteAR,
    bounceCheck,
    clearCredits,
    clearARForm,
    checkPassword,
    clearCheckPassword,
    setDefaultOfForm
  })(editARForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/AR/editAR.jsx